import { render } from "./EventDetails.vue?vue&type=template&id=2131095c&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=2131095c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2131095c"

export default script